/**
 * In this file, we create a React component
 * which incorporates components provided by Material-UI.
 */
import React from 'react';
import queryString from 'query-string';

import { WithLocalize } from "../../containers/I18nProvider";
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';
import LoginForm from './LoginForm';

class Login extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.api = new ServiceApi(this);
    this.parameters = queryString.parse(props.location.search);

  }

  _validateParams() {
    if (!this.parameters.client_id || !this.parameters.redirect_uri || !this.parameters.response_type) {
      return false;
    }
    return true;
  }

  componentDidMount() {
    document.body.className = 'cablecolor-body';
    document.title = 'Ingreso de Usuarios a Plataforma';
  }

  render() {
    const {translate} = this.props;

    return (
      <div className="cablecolor-container">
       <div className="cablecolor-h1">Video On Demand</div>
          {
            this._validateParams()
            ? <LoginForm
                api={this.api}
                location={this.props.location}
              />
            : <RequestLoginErrorMessage
                onlyMessage={true}
                message={translate('RequestLoginErrorMessage')}
              />
          }
      </div>
    );
  }
}

export default WithLocalize(Login);
